import { useImageSize } from "react-image-size";
import EUB_FV_Put from "../../../images/spiderpopups/VVSpiderPopUps_EUBPutRatio_v1a.jpg";
import SUP_RES from "../../../images/spiderpopups/VVSpiderPopUps_SRRatio.jpg";
import STRADDLE from "../../../images/spiderpopups/VVSpiderPopUps_Straddle.jpg";
import UP_SKEW from "../../../images/spiderpopups/VVSpiderPopUps_UpSkew.jpg";
import WGT_UP_ANGLES from "../../../images/spiderpopups/VVSpiderPopUps_WgtUpAngles.jpg";
import AVG_DOWN_ANGLE from "../../../images/spiderpopups/VVSpiderPopUps_AvgDownAngle.jpg";
import AVG_UP_ANGLE from "../../../images/spiderpopups/VVSpiderPopUps_AvgUpAngle.jpg";
import AVG_TOP_AGE_BOT from "../../../images/spiderpopups/VVSpiderPopUps_AgeTopAgeBot.jpg";
import LAST_BOT_AGE from "../../../images/spiderpopups/VVSpiderPopUps_LastBotAge.jpg";
import LAST_TOP_AGE from "../../../images/spiderpopups/VVSpiderPopUps_LastTopAge.jpg";
import BOT_BOT_PROX from '../../../images/spiderpopups/VVSpiderPopUps_BotBotProximity.jpg';
import TOP_TOP_PROX from "../../../images/spiderpopups/VVSpiderPopUps_TopTopProximity.jpg";
import UP_TAIL_DOWN_TAIL from "../../../images/spiderpopups/VVSpiderPopUps_UpTailDownTail.jpg";

const imageRef = {
  "EUB/ FV Put": EUB_FV_Put,
  "#Sup/ #Res": SUP_RES,
  "Straddle FV": STRADDLE,
  "Up Skew": UP_SKEW,
  "Wgt Up Angles": WGT_UP_ANGLES,
  "Avg Down Angle": AVG_DOWN_ANGLE,
  "Avg Up Angle": AVG_UP_ANGLE,
  "Age Top / Age Bot": AVG_TOP_AGE_BOT,
  "Last Bot Age": LAST_BOT_AGE,
  "Last Top Age": LAST_TOP_AGE,
  "Bot Bot Prox": BOT_BOT_PROX,
  "Top Top Prox": TOP_TOP_PROX,
  "Up Tail / Down Tail": UP_TAIL_DOWN_TAIL,
};

const designwidth = 600;
const designheight = 400;

function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
  var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return { width: srcWidth * ratio, height: srcHeight * ratio };
}

export const PopupImage = ({ hoveredLabel, width, height }) => {
  const [dimensions] = useImageSize(imageRef[hoveredLabel.label]);

  const popupstyle = {
    height: designheight,
    width: designwidth,
    position: "absolute",
    left: width / 2 - designwidth / 2,
    top: height / 2 - designheight / 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none",
  };

  if (dimensions) {
    const newdim = calculateAspectRatioFit(
      dimensions.width,
      dimensions.height,
      designwidth,
      designheight
    );

    const imageStyle = {
      width: newdim.width,
      height: newdim.height,
      border: "2px solid black",
      borderRadius: 5,
      pointerEvents: "none",
    };

    return (
      <div style={popupstyle}>
        <img
          style={imageStyle}
          alt={"x"}
          src={imageRef[hoveredLabel.label]}
        ></img>
      </div>
    );
  } else {
    return null;
  }
};
